//@constants
const actionTypes = require('constants/actionTypes');

const selectedOptionChanged = selectedOption => ({
    type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SELECTED_OPTION_CHANGED,
    payload: {
        selectedOption
    }
});

function setContractNumber(selectedContract) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_CONTRACT_NUMBER,
        payload: {
            selectedContract
        }
    };
}

function setAccessFrom(type) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_ACCESS_FROM,
        payload: {
            type
        }
    };
}

function reset() {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_RESET,
    };
}

function setStateOperationFilter(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_STATE_OPERATIONS_FILTER,
        payload: value
    };
}

function setCheckContributions(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_CONTRIBUTIONS,
        payload: value
    };
}

function setCheckSubscription(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_SUBSCRIPTION,
        payload: value
    };
}

function setCheckReimbursement(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_REIMBURSEMENT,
        payload: value
    };
}

function setCheckTransfer(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET_IS_CHECK_TRANSFER,
        payload: value
    };
}

function setMaxDateFilter(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET__MAX_DATE,
        payload: value
    };
}

function setMinDateFilter(value) {
    return {
        type: actionTypes.BROKER_ORDERS_AND_MOVEMENTS_SET__MIN_DATE,
        payload: value
    };
}

module.exports = {
    selectedOptionChanged,
    setCheckContributions,
    setCheckSubscription,
    setCheckReimbursement,
    setCheckTransfer,
    setContractNumber,
    setAccessFrom,
    setStateOperationFilter,
    reset,
    setMaxDateFilter,
    setMinDateFilter
};
